export default __webpack_public_path__ + "media/images/icons/bars-solid-e8db7520285d01597a75c139d54e29ce.svg";